// import { DoubleArrowDownIcon } from "@radix-ui/react-icons";
import { useQuery } from "@tanstack/react-query";
import Cookies from "js-cookie";
import { useMemo } from "react";
import { ColumnDef } from "@tanstack/react-table";

import { useDateRangeStore } from "./_components/date-range-picker/use-date-range-store";

import { convertUTCtoIST } from "@/utils";
import { Lead } from "./_components/leads-table/schema";
import { getColumns } from "./_components/leads-table/columns";
import { DataTable } from "./_components/leads-table/data-table";
import { DateRangePicker } from "./_components/date-range-picker/date-range-picker2";

import { fetchAllLeadsForAdminQueryOptions } from "@/config/queries/query-options";
import { ViewLeadLogsModal } from "./_components/view-lead-logs/view-lead-logs-modal";

const LeadsAdminPage = () => {
  const key = Cookies.get("key") as string;
  const { dateRange } = useDateRangeStore();

  const startdate = dateRange?.from as Date;
  const enddate = dateRange?.to as Date;

  const { data, isPending, isFetching } = useQuery(
    fetchAllLeadsForAdminQueryOptions(key, {
      startdate: convertUTCtoIST(new Date(startdate.setHours(0))),
      enddate: convertUTCtoIST(new Date(enddate.setHours(23))),
    })
  );

  const leadsData = useMemo(() => {
    if (isPending) {
      return [];
    }

    if (data === undefined || data?.leads === undefined) {
      return [];
    }

    const result = data?.leads?.map((lead) => {
      return {
        id: lead?._id,
        name: lead?.name,
        status: lead?.status,
        originalStatus: lead?.originalStatus,
        phone: lead?.phone,
        alloted: lead?.alloted,
        ...(lead?.allotedAt
          ? {
              allotedAt: lead?.allotedAt as string | Date,
            }
          : {}),

        ...(lead?.allotedTo
          ? {
              allotedTo: lead?.allotedTo?.name,
              allotedToEmail: lead?.allotedTo?.email,
            }
          : { allotedTo: "No One", allotedToEmail: "" }),
        createdAt: lead?.createdAt,
        broker: lead?.broker,
      };
    });

    return result;
  }, [data, isPending, isFetching]) as {
    id: string;
    name: string;
    status: string;
    originalStatus: string;
    phone: string;
    alloted: boolean;
    allotedAt: string | Date;
    createdAt: string | Date;
    broker: string;
  }[];

  const columns = useMemo<ColumnDef<Lead, unknown>[]>(() => getColumns(), []);

  return (
    <div className="p-5 h-[calc(100%-56px)]">
      <div className="flex items-center justify-between">
        <h3 className="text-2xl font-medium">Leads</h3>

        <div className="flex items-center gap-2">
          <DateRangePicker />
        </div>
      </div>

      <div className="mt-5 mb-10 pb-10">
        <DataTable data={leadsData} columns={columns} />
      </div>

      {/* <TakeActionOnLeadModal /> */}
      <ViewLeadLogsModal />
    </div>
  );
};

export default LeadsAdminPage;
